import actionTypes from '../constants/action-types';

const setPublishCount = (publishCount) => ({
  type: actionTypes.SET_PUBLISH_COUNT,
  payload: { publishCount },
});

export default setPublishCount;
